<template>
  <b-modal ref="modal" class="no-header" visible size="lg" hide-header=true :hide-footer="true" title="1-9 van 9 Urenregistraties" @hidden="$emit('close')">
   <hour-registration-table ref="registrationTable" :userId="userId" role="admin"></hour-registration-table>
  </b-modal>
</template>
<script>
import HourRegistrationTable from '../employees/HourRegistrationTable.vue'

export default {
  components: {
    HourRegistrationTable
  },
  props: {
    userId: Number
  }
}
</script>


// WEBPACK FOOTER //
// HourRegistrationModal.vue?4fe58d7c